// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loading-overlay{position:absolute;width:100%;height:100%;background-color:rgba(255,255,255,0.4);z-index:999;transition:opacity 250ms ease-in;opacity:1}.loading-overlay.hidden{opacity:0;z-index:-999}.loading-center{display:block;width:50px;margin:10em auto}\n", ""]);
// Exports
module.exports = exports;
